(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("ab8uU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $769185e8fd5a519c$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $6MRuB = parcelRequire("6MRuB");
var $769185e8fd5a519c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function MasonryGrid(param) {
        var el = param.el;
        (0, $J7ygF._)(this, MasonryGrid);
        this.el = el;
        this.items = Array.from(this.el.querySelectorAll('.grid-item'));
        this.columns = Array.from(this.el.querySelectorAll('.grid-col'));
        this.init();
    }
    (0, $hvJJn._)(MasonryGrid, [
        {
            key: "init",
            value: function init() {
                this.distributeItems();
                (0, $6MRuB.onResizeStop)(this.distributeItems);
            }
        },
        {
            key: "distributeItems",
            value: function distributeItems() {
                // Clear existing content in grid-cols
                this.columns.forEach(function(col) {
                    return col.innerHTML = '';
                });
                // Get visible columns
                var visibleCols = this.columns.filter(function(col) {
                    return window.getComputedStyle(col).display !== 'none';
                });
                // Distribute items sequentially across columns
                for(var i = 0; i < this.items.length; i++){
                    var col = visibleCols[i % visibleCols.length];
                    col.appendChild(this.items[i]);
                }
                if (!this.el.classList.contains('active')) this.el.classList.add('active');
            }
        }
    ]);
    return MasonryGrid;
}();

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("6MRuB", function(module, exports) {

$parcel$export(module.exports, "fetchConfig", function () { return $4f10b8437ab12d6c$export$1811237fdf5ac5d; });
$parcel$export(module.exports, "onResizeStop", function () { return $4f10b8437ab12d6c$export$a9b3c4888c857dcf; });
function $4f10b8437ab12d6c$export$1811237fdf5ac5d() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'json';
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: "application/".concat(type)
        }
    };
}
var $4f10b8437ab12d6c$export$a9b3c4888c857dcf = function(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 66;
    var scrollingTimeout = false;
    var handleScroll = function(event) {
        clearTimeout(scrollingTimeout);
        scrollingTimeout = setTimeout(function() {
            callback(event);
        }, delay);
    };
    window.addEventListener('resize', handleScroll);
    return function() {
        window.removeEventListener('resize', handleScroll);
    };
};

});


})();
//# sourceMappingURL=MasonryGrid.7424a833.js.map
